import { useTranslation } from 'react-i18next'
// material
import {
  Stack,
  Button,
  Grid,
  Card
} from '@mui/material';
import { styled } from "@mui/material/styles";
import { useNavigate } from 'react-router-dom';
import Page from '../components/Page';


const RootStyle = styled(Page)(() => ({
  height: '100%',
  width: '100%',
  position: 'absolute',
  backgroundImage: "url(/static/graphics/blurBackground.jpg)",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  alignItems:'center',
  display:'flex',
}));


export default function LanguageSelector(props) {
  const { t, i18n } = useTranslation('translation')
  const navigate = useNavigate()

  const setLanguageEnglish = () => {
    i18n.changeLanguage("en")
    navigate('/en/home')
  };

  const setLanguageFrench = () => {
    i18n.changeLanguage("fr")
    navigate('/fr/home')
  };

  return (
    <RootStyle title={"NRCan Mining Assistance Tool"}>
    <Grid container mt={10} xs ={12} md={12} style={{ display: 'flex', justifyContent: 'center' }}>
      <Card>
          <Grid container item xs ={12} style={{ display: 'flex', justifyContent: 'center' }}>
            <Grid item xs ={12} style={{ textAlign: 'center' }}>
              <h2>Welcome to the NRCan Mining Assistance Tool</h2>
              <h2>Bienvenue à l'outil d'aide au secteur minier de RNCan</h2>
            </Grid>
            <Grid item xs ={6} style={{ display: 'flex', justifyContent: 'center' }} mt={2} mb={5}> 
                <Button variant="contained" sx={{width: '80%'}} onClick={() => setLanguageEnglish()}>{t("English")}</Button>
            </Grid>
            <Grid item xs ={6} style={{ display: 'flex', justifyContent: 'center' }} mt={2} mb={5}>
                <Button variant="contained" sx={{width: '80%'}} onClick={() => setLanguageFrench()}>{t("French")}</Button>
            </Grid>
          </Grid>
      </Card>
    </Grid>
    </RootStyle>
  );
}
